import SeoHead from '../../components/SeoHead';
import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk"
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import Clients from '../../components/Clients';
import LatestJobs from '../../components/LatestJobs';
import SpecialismDetail from '../../components/SpecialismDetail';
import Header from '../../components/MainHeader';
import OurValues from '../../components/OurValues';
import TextWithCTA from '../../components/TextWithCTA';
import SimplePage from '../../components/SimplePage';

export default function JobSeekerIndividualSpecialism({
    global,
    specialism,
    all_clients,
    all_jobs,
    all_sub_specialisms
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${specialism.title}`}
                // description={``}
                canonical_link={`/job-seekers-specialisms/${specialism.url_slug}/`}
            />
            <Header
                employerNav={false}
                slug_url={`${specialism.url_slug}`}
            />
            <SubBanner
                global={global}
                pathPrefix={`job_seekers_specialsm_page.sub_banner`}
                customClass={`mb-5 pb-5 secondary-banner`}
                buttonTitle={`Jobseekers  /  Job categories`}
                buttonLink={`/job-seekers-specialisms/`}
                consultantPage={false}
                heading={`${specialism.title}`}
                post={specialism}
                bannerImageAlt={`${specialism.title} Banner Image`}
                bannerImageAlt2={`${specialism.title} Banner Image 2`}
                bannerImage={`${specialism.image ? specialism.image : "/site-assets/images/image-placeholder.webp"}`}
                bannerImage2={`${specialism.secondary_image ? specialism.secondary_image : "/site-assets/images/image-placeholder.webp"}`}
                dualBannerImage={true}
            />
            <TextWithCTA
                global={global}
                pathPrefix={`job_seekers_specialsm_page.text_with_cta`}
                customClass={`mt-5 mb-5 pb-lg-5`}
                link1={`/job-seekers-get-in-touch`}
                link2={`/recruit-staff/`}
                column1={true}
                column2={false}
                buttonTitle1={
                    <>
                        <strong>
                            Get a callback
                        </strong> and we'll help you find your next role
                    </>
                }
                buttonTitle2={
                    <>
                        <strong>
                            Recruit staff
                        </strong> let us help your fill your next role
                    </>
                }
                fullWidth={true}
                mainButtonTitle1={`Get in touch`}
                mainButtonLink1={`/job-seekers-get-in-touch/`}
                brandLogo={true}
            />
            <OurValues
                global={global}
                pathPrefix={`job_seekers_specialsm_page.our_values`}
                customClass='mt-lg-5 mb-5 pt-lg-5 pb-lg-5 secondaryColor'
                sub_heading_1={``}
                sub_heading_2={``}
                sub_heading_3={``}
                content_1={`Driver CPC training aims to enhance road safety, improve driver skills, and ensure professional standards amongst commercial drivers.`}
                content_2={`To work with our clients all of our drivers must have already obtained their initial Driver CPC qualification, including the theory test, practical driving test, and case study test, undertaking 35 hours of periodic training every 5 years to maintain their qualification.`}
                content_3={`But did you know we’re a fully qualified driving school for CPC training? We’re committed to helping you stay up to date with safe driving practices, so if you’d like us to support you through your initial training, or ensure you continue to improve your skills with approved periodic training modules, we’re here to help.`}
                heading={``}
                imageSrc1={`/site-assets/images/our-values-1.jpg`}
                imageSrc2={`/site-assets/images/our-values-2.jpg`}
                imageSrc3={`/site-assets/images/our-values-3.jpg`}
                imageAlt1={`Our value 1`}
                imageAlt2={`Our value 2`}
                imageAlt3={`Our value 3`}
                urlSlug={`${specialism.url_slug}`}
            />
            <SpecialismDetail
                global={global}
                pathPrefix={`job_seekers_specialsm_page.specialism_detail`}
                customClass={`${specialism.url_slug != "cpc-training" ? "mb-5 pb-5" : "mt-5 pt-5 mb-5 pb-5"}`}

                specialism={specialism}
                sub_specialisms={all_sub_specialisms}
                heading={`Some of the roles we recruit for`}
                enableSpecialismContent={true}
                brandLogo={false}
                content=
                {
                    <>
                        {specialism?.job_seeker_content ?
                            <div className="description p-lg-5 p-4" dangerouslySetInnerHTML={{ __html: specialism?.job_seeker_content }} />
                            : ""}
                    </>
                }
            />
            <LatestJobs
                global={global}
                pathPrefix={`job_seekers_specialsm_page.latest_jobs`}
                customClass={`mt-3 mb-5`}
                buttonTitle={``}
                buttonLink={``}
                heading={`${specialism?.title} jobs.`}
                subtitle={`jobseekers`}
                all_jobs={all_jobs}
                label={false}
                headingFullWidth={true}
                headingTextCenter={true}
                editableText={false}

            />
            {/* <SimplePage
                global={global}
                pathPrefix={`job_seekers_specialsm_page.simple_page`}
                customClass={`mt-5 pt-5 mb-5 pb-5 pb-md-0`}
                content={
                    <>
                        <h2>Talk to us about Driver CPC training</h2>
                        <p>We’re a fully qualified driving school able to support drivers through their initial and ongoing periodic training. You can find out more <Link href="/job-seekers-specialisms/cpc-training/"><a className
                            ="text-decoration-none">here</a></Link>.</p>
                    </>
                }
                textCenter={true}
            /> */}
            <Clients
                global={global}
                pathPrefix={`job_seekers_specialsm_page.all_clients`}
                all_clients={all_clients}
                customClass={`pt-lg-5 pb-5 mt-lg-5 mb-5`}
                heading={`Accreditations and partnerships`}
            />
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const specialism = (await Collection('specialisms')).getJsonItem(params.url_slug, 'url_slug');
    const all_specialisms = await Collection('specialisms');
    const all_sub_specialisms = all_specialisms.orderBy('order')
        // Pulls parent sector only
        .filter(function (sector) {
            return (
                sector.specialism_tag?.en.includes(specialism.title)
            )
        }).getItems()
    // sector.specialism_tag?.en === specialism.title);
    const clients = await Collection('accreditations');
    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    // Pulls specialism sector category
                    .find((cat) => cat.id === "3a20dd80-6b03-4bf4-b611-b51819c37094")
                    // ?.values?.includes(specialism.id)
                    ?.values?.map(cat => cat.id).includes(specialism.id)

            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 10);


    const all_clients = clients.orderBy('order').getItems();
    return {
        props: {
            global,
            specialism,
            all_clients,
            all_jobs,
            all_sub_specialisms
        },
    }
}

export async function getStaticPaths() {
    const pagePath = (await Collection('specialisms')).getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: false
    }
}